module.exports = __webpack_public_path__ + "img/108.2a2033fb.jpg";